<h3 class="small inline-block rounded-full bg-gray-light px-8 py-4">
  {{ text | titlecase }}
</h3>
